<template>
  <!-- 主容器 -->
  <div class="app-container">

    <!-- 管理员搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px" v-if="identity === 'admin'||identity==='teacher'">
      <!-- 学生姓名搜索 -->
      <el-form-item label="学生姓名" prop="nickName">
        <el-input v-model="queryParams.nickName" placeholder="请输入学生姓名" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 作品名称搜索 -->
      <el-form-item label="作品名称" prop="workTitle">
        <el-input v-model="queryParams.workTitle" placeholder="请输入作品名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 专业选择搜索 -->
      <el-form-item label="所属专业" prop="majorId">
        <el-select v-model="queryParams.majorId" placeholder="请选择专业" clearable size="small">
          <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
            :value="major.majorId" />
        </el-select>
      </el-form-item>

      <!-- 班级选择搜索 -->
      <el-form-item label="所属班级" prop="classId">
        <el-select v-model="queryParams.classId" placeholder="请选择班级" clearable size="small">
          <el-option v-for="cls in classOptions" :key="cls.id" :label="cls.className" :value="cls.id" />
        </el-select>
      </el-form-item>

       <el-form-item label="学期" prop="xueQi">
        <el-select
          v-model="queryParams.xueQi"
          placeholder="请选择学期"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in semesterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </el-form-item>
     
      <el-form-item label="阶段" prop="stage">
        <el-select
          v-model="queryParams.stage"
          placeholder="请选择阶段"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in stageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 评价等级搜索 -->
      <el-form-item label="评价状态" prop="commentLevel">
        <el-select v-model="queryParams.commentLevel" placeholder="请选择评价状态" clearable size="small">
          <el-option label="合格" value="合格" />
          <el-option label="优秀" value="优秀" />
          <el-option label="良好" value="良好" />
          <el-option label="留校" value="留校" />
          <el-option label="未点评" value="未点评" />
        </el-select>
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

     <!-- 学生搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true"  v-if="identity === 'student'" label-width="70px">
    
      <!-- 作品名称搜索 -->
      <el-form-item label="作品名称" prop="workTitle">
        <el-input v-model="queryParams.workTitle" placeholder="请输入作品名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

       <el-form-item label="学期" prop="xueQi">
        <el-select
          v-model="queryParams.xueQi"
          placeholder="请选择学期"
          clearable
          size="small"
          style="width: 115px"
        >
          <el-option
            v-for="item in semesterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </el-form-item>
     
      <el-form-item label="阶段" prop="stage">
        <el-select
          v-model="queryParams.stage"
          placeholder="请选择阶段"
          clearable
          size="small"
          style="width: 115px"

        >
          <el-option
            v-for="item in stageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 评价等级搜索 -->
      <el-form-item label="评价状态" prop="commentLevel">
        <el-select v-model="queryParams.commentLevel" placeholder="请选择评价状态" clearable size="small" >
          <el-option label="合格" value="合格" />
          <el-option label="优秀" value="优秀" />
          <el-option label="良好" value="良好" />
          <el-option label="留校" value="留校" />
           <el-option label="未点评" value="未点评" />
        </el-select>
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8">
      <!-- 新增按钮
      <el-col :span="1.5" 先注释，后期修改>
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd" v-if="identity === 'student'">
          新增
        </el-button>
      </el-col> -->

      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="worksList" @selection-change="handleSelectionChange" class="table-container">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 作品编号列 -->
      <el-table-column label="作品编号" align="center" width="100">
        <template slot-scope="scope">
          OMD{{ scope.row.id }}
        </template>
      </el-table-column>

       <!-- 作品名称列 -->
      <el-table-column label="作品名称" align="center" prop="workTitle"  width="120"/>

      <!-- 学生姓名列 -->
      <el-table-column label="学生姓名" align="center" prop="nickName"  />

      <!-- 所属专业列 -->
      <el-table-column label="专业" align="center" prop="majorName" />

      <!-- 所属班级列 -->
      <el-table-column label="班级" align="center" prop="className" />

      <!-- 学期列 -->
      <el-table-column label="学期" align="center" prop="xueQi" />

      <!-- 所属学期阶段列 -->
      <el-table-column label="阶段" align="center" prop="stageDisplay" />

  
      <!-- 创作日期列 -->
      <el-table-column label="创作日期" align="center" prop="workScreatetime" width="120" />

      <!-- 作品缩略图列 -->
      <el-table-column label="缩略图" align="center" width="100">
        <template slot-scope="scope">
          <el-image :src="scope.row.workMedia" :preview-src-list="[scope.row.workMedia]" style="width: 40px; height: 40px;">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>

      <!-- 作品评价等级列 -->
      <el-table-column label="作品评价" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.commentLevel">{{ scope.row.commentLevel }}</span>
          <span v-else style="color: red;">未点评</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="185">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>

          <!-- 删除按钮 -->
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>

          <!-- 评价按钮（仅管理员和教师可见） -->
          <el-button size="mini" type="text" icon="el-icon-edit-outline" @click="handleComment(scope.row)"
            v-if="identity === 'admin' || identity === 'teacher'">
            评价
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">

         <!-- 作品图片上传 -->
        <el-form-item label="作品图片" prop="workMedia">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleUploadSuccess"
            :headers="headers">
            <img v-if="form.workMedia" :src="form.workMedia" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> 
        <!-- 作品名称输入 -->
        <el-form-item label="作品名称" prop="workTitle">
          <el-input v-model="form.workTitle" placeholder="请输入作品名称" />
        </el-form-item>

        <!-- 专业选择 -->
        <el-form-item label="所属专业" prop="majorId">
          <el-select v-model="form.majorId" placeholder="请选择专业">
            <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
              :value="major.majorId" />
          </el-select>
        </el-form-item>

        

        <!-- 创作日期选择 -->
        <el-form-item label="创作日期" prop="workScreatetime">
          <el-date-picker v-model="form.workScreatetime" type="date" value-format="yyyy-MM-dd" placeholder="选择创作日期"
            style="width: 100%" />
        </el-form-item>

       

        <el-form-item label="所属学期" prop="xueQi">
          <el-select 
            v-model="form.xueQi" 
            placeholder="请选择学期"
            class="form-select"
          >
            <el-option
              v-for="(item, index) in 6"
              :key="index"
              :label="`第${index + 1}学期`"
              :value="`第${index + 1}学期`"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属学期阶段" prop="stage">
          <el-select 
            v-model="form.stage" 
            placeholder="请选择阶段"
            class="form-select">
            <el-option
              v-for="(item, index) in 4"
              :key="index"
              :label="`第${index + 1}阶段`"
              :value="index + 1"
            ></el-option>
          </el-select>
        </el-form-item>
   


        <el-form-item label="排序序号" prop="sortNum">
          <el-input 
            v-model="form.sortNum" 
            placeholder="序号越大越靠前" 
            class="form-input"
          ></el-input>
          <div class="upload-tip">序号越大，作品显示越靠前,默认为 0。</div>
        </el-form-item>
    
      
      </el-form>

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 评价对话框 -->
    <el-dialog title="作品评价" :visible.sync="commentOpen" width="600px" append-to-body>
      <el-form ref="commentForm" :model="commentForm" :rules="commentRules" label-width="100px">
        <el-form-item label="学生姓名">
          <el-input v-model="commentForm.nickName" disabled />
        </el-form-item>
        <el-form-item label="作品名称">
          <el-input v-model="commentForm.workTitle" disabled />
        </el-form-item>
        <el-form-item label="作品图片">
          <el-image :src="commentForm.workMedia" style="width: 230px; height: 264px;" fit="contain" />
        </el-form-item>
        <el-form-item label="评价等级" prop="commentLevel">
          <el-select v-model="commentForm.commentLevel" placeholder="请选择评价等级">
            <el-option label="合格" value="合格" />
            <el-option label="优秀" value="优秀" />
            <el-option label="良好" value="良好" />
            <el-option label="留校" value="留校" />
          </el-select>
        </el-form-item>
        <el-form-item label="评语内容" prop="commentContent">
          <el-input type="textarea" v-model="commentForm.commentContent" :rows="4" placeholder="请输入评语内容" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitComment">确 定</el-button>
        <el-button @click="commentOpen = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import worksmian from '@/js/worksmian';
export default {
    ...worksmian
}
</script>
<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}

/* 图片上传样式 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>